(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["explorar-destinos-continente"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initExplorer(root) {
    if (!root || root.dataset.edReady === 'true') return;
    root.dataset.edReady = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-ed-trigger]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-ed-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ed-card]'));
    var emptyMsg = root.querySelector('[data-ed-empty]');
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function closeAllMenus(exceptTrigger) {
      triggers.forEach(function (t) {
        if (t === exceptTrigger) return;
        t.setAttribute('aria-expanded', 'false');
        var menu = t.parentElement.querySelector('[data-ed-menu]');
        if (menu) menu.hidden = true;
      });
    }

    function toggleMenu(trigger) {
      var menu = trigger.parentElement.querySelector('[data-ed-menu]');
      if (!menu) return;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAllMenus(isOpen ? null : trigger);
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      menu.hidden = isOpen;
    }

    function openMenu(trigger) {
      var menu = trigger.parentElement.querySelector('[data-ed-menu]');
      if (!menu) return;
      closeAllMenus(trigger);
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
    }

    function setActiveTrigger(filterEl) {
      triggers.forEach(function (t) { t.classList.remove('is-active'); });
      filters.forEach(function (f) { f.classList.remove('is-active'); });
      if (filterEl) {
        filterEl.classList.add('is-active');
        var t = filterEl.querySelector('[data-ed-trigger]');
        if (t) t.classList.add('is-active');
      }
    }

    function clearHighlight() {
      cards.forEach(function (c) { c.classList.remove('is-highlighted'); });
    }

    function applyFilter(opts) {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var show = true;
        if (opts.type === 'continent') {
          show = card.getAttribute('data-continent') === opts.continent;
        } else if (opts.type === 'collection') {
          show = card.getAttribute('data-collection') === opts.collection;
        }
        card.hidden = !show;
        if (show) visibleCount++;
      });
      if (emptyMsg) emptyMsg.hidden = visibleCount !== 0;
    }

    // Abrir / cerrar menús y filtrar por continente al pulsar el disparador
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var filterEl = trigger.closest('[data-ed-filter]');
        var type = filterEl.getAttribute('data-filter-type');
        setActiveTrigger(filterEl);
        clearHighlight();
        if (type === 'all') {
          applyFilter({ type: 'all' });
        } else if (type === 'continent') {
          applyFilter({ type: 'continent', continent: filterEl.getAttribute('data-continent') });
        }
        // En desktop el menú ya se abre con el hover; en táctil se alterna con el clic.
        if (canHover) { openMenu(trigger); } else { toggleMenu(trigger); }
      });
    });

    // Apertura por hover en dispositivos con cursor (desktop)
    if (canHover) {
      filters.forEach(function (filterEl) {
        var trigger = filterEl.querySelector('[data-ed-trigger]');
        if (!trigger) return;
        filterEl.addEventListener('mouseenter', function () {
          openMenu(trigger);
        });
        filterEl.addEventListener('mouseleave', function () {
          trigger.setAttribute('aria-expanded', 'false');
          var menu = filterEl.querySelector('[data-ed-menu]');
          if (menu) menu.hidden = true;
        });
      });
    }

    // Selección dentro de un menú
    root.querySelectorAll('[data-ed-select]').forEach(function (item) {
      item.addEventListener('click', function (e) {
        e.stopPropagation();
        var target = item.getAttribute('data-target');
        var filterEl = item.closest('[data-ed-filter]');
        setActiveTrigger(filterEl);
        clearHighlight();

        if (target === 'all') {
          applyFilter({ type: 'all' });
        } else if (target === 'continent') {
          applyFilter({ type: 'continent', continent: item.getAttribute('data-continent') });
        } else if (target === 'collection') {
          var handle = item.getAttribute('data-collection');
          applyFilter({ type: 'collection', collection: handle });
          var match = root.querySelector('[data-ed-card][data-collection="' + handle + '"]');
          if (match) match.classList.add('is-highlighted');
        }

        // marca el item activo dentro de su menú
        var menu = item.closest('[data-ed-menu]');
        if (menu) {
          menu.querySelectorAll('.ed__menu-item').forEach(function (mi) { mi.classList.remove('is-active'); });
          item.classList.add('is-active');
        }
        closeAllMenus(null);
      });
    });

    // Cerrar al hacer clic fuera
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAllMenus(null);
    });

    // Cerrar con Escape
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeAllMenus(null);
        var open = root.querySelector('[data-ed-trigger][aria-expanded="true"]');
        if (open) open.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ed-root]').forEach(initExplorer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor: reinicializa al añadir/recargar la sección
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ed-root]');
    if (root) { root.dataset.edReady = 'false'; initExplorer(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuestras-oficinas-zondela"] && !Shopify.designMode) return;
  try {
    
(function () {
  function injectMap(mapEl) {
    if (!mapEl || mapEl.dataset.mapLoaded === 'true') return;
    var src = mapEl.getAttribute('data-map-src');
    if (!src) return;
    mapEl.dataset.mapLoaded = 'true';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', 'Mapa — ' + (mapEl.getAttribute('data-map-title') || 'Oficina'));
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    iframe.setAttribute('allowfullscreen', '');
    iframe.addEventListener('load', function () {
      var loader = mapEl.querySelector('.zofi__map-loading');
      if (loader) loader.style.display = 'none';
    });
    mapEl.appendChild(iframe);
  }

  function initAccordion(root) {
    if (!root || root.dataset.zofiReady === 'true') return;
    root.dataset.zofiReady = 'true';

    var single = root.getAttribute('data-single') === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-zofi-item]'));

    // Con JS activo, la clase is-open controla la apertura: retira el atributo
    // hidden de todos los paneles para que la animación grid funcione siempre.
    root.querySelectorAll('[data-zofi-panel][hidden]').forEach(function (p) {
      p.removeAttribute('hidden');
    });

    // Cargar mapas ya abiertos (open_first) de inmediato.
    root.querySelectorAll('[data-zofi-map][data-eager="true"]').forEach(injectMap);

    function setOpen(item, open) {
      var trigger = item.querySelector('[data-zofi-trigger]');
      item.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var map = item.querySelector('[data-zofi-map]');
        if (map) injectMap(map);
      }
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-zofi-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        // Marca de tiempo: evita que shopify:block:select reabra tras un clic manual.
        root._zofiLastToggle = Date.now();
        var willOpen = !item.classList.contains('is-open');
        if (single && willOpen) {
          items.forEach(function (other) {
            if (other !== item && other.classList.contains('is-open')) setOpen(other, false);
          });
        }
        setOpen(item, willOpen);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-zofi-root]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor: reinicializa al recargar la sección.
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-zofi-root]');
    if (r) { r.dataset.zofiReady = 'false'; initAccordion(r); }
  });
  // Al seleccionar un bloque desde la barra lateral del editor, abre esa oficina.
  // Si la selección viene de un clic en el preview que el usuario hizo para CERRAR,
  // se ignora (guard de tiempo) para no reabrirla.
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('[data-zofi-item]');
    var root = e.target.closest('[data-zofi-root]');
    if (!item || !root) return;

    // Si el usuario acaba de alternar con un clic, respeta su acción.
    if (root._zofiLastToggle && (Date.now() - root._zofiLastToggle) < 500) return;

    var single = root.getAttribute('data-single') === 'true';
    if (single) {
      root.querySelectorAll('[data-zofi-item].is-open').forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var t = other.querySelector('[data-zofi-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    }
    if (!item.classList.contains('is-open')) {
      item.classList.add('is-open');
      var trg = item.querySelector('[data-zofi-trigger]');
      if (trg) trg.setAttribute('aria-expanded', 'true');
      var map = item.querySelector('[data-zofi-map]');
      if (map) injectMap(map);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuestros-pilares"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPilares(root) {
    if (!root || root.dataset.npReady === 'true') return;
    root.dataset.npReady = 'true';

    var pillars = Array.prototype.slice.call(root.querySelectorAll('[data-np-pillar]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-np-slide]'));
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-np-trigger]'));
    if (!pillars.length) return;

    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var enableHover = root.classList.contains('np--hover');
    var current = 0;

    function activate(index) {
      if (index === current) return;
      current = index;

      pillars.forEach(function (p) {
        var on = parseInt(p.getAttribute('data-index'), 10) === index;
        p.classList.toggle('is-active', on);
        var trg = p.querySelector('[data-np-trigger]');
        if (trg) {
          trg.setAttribute('aria-selected', on ? 'true' : 'false');
          trg.setAttribute('tabindex', on ? '0' : '-1');
        }
        var cta = p.querySelector('.np__pillar-cta');
        if (cta) cta.setAttribute('tabindex', on ? '0' : '-1');
      });

      slides.forEach(function (s) {
        var on = parseInt(s.getAttribute('data-np-slide'), 10) === index;
        s.classList.toggle('is-active', on);
        if (on) {
          s.removeAttribute('aria-hidden');
        } else {
          s.setAttribute('aria-hidden', 'true');
        }
      });
    }

    pillars.forEach(function (pillar) {
      var index = parseInt(pillar.getAttribute('data-index'), 10);
      var trigger = pillar.querySelector('[data-np-trigger]');

      if (canHover && enableHover) {
        pillar.addEventListener('mouseenter', function () { activate(index); });
      }

      if (trigger) {
        trigger.addEventListener('click', function () { activate(index); });
        trigger.addEventListener('focus', function () { activate(index); });
      }
    });

    var list = root.querySelector('[data-np-list]');
    if (list) {
      list.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'Home' && key !== 'End') return;
        e.preventDefault();
        var next = current;
        if (key === 'ArrowDown') next = (current + 1) % triggers.length;
        else if (key === 'ArrowUp') next = (current - 1 + triggers.length) % triggers.length;
        else if (key === 'Home') next = 0;
        else if (key === 'End') next = triggers.length - 1;
        activate(next);
        if (triggers[next]) triggers[next].focus();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.querySelectorAll('.np__image[loading="lazy"]').forEach(function (img) {
              img.setAttribute('loading', 'eager');
            });
            io.disconnect();
          }
        });
      }, { rootMargin: '300px' });
      io.observe(root);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-np-root]').forEach(initPilares);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-np-root]');
    if (r) { r.dataset.npReady = 'false'; initPilares(r); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var r = e.target.closest('[data-np-root]');
    var pillar = e.target.closest('[data-np-pillar]');
    if (r && pillar) {
      var idx = parseInt(pillar.getAttribute('data-index'), 10);
      var trg = pillar.querySelector('[data-np-trigger]');
      if (trg) trg.click();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
